<p-autoComplete #autoCompleteComponent [(ngModel)]="value" [suggestions]="suggestions()" [optionLabel]="optionLabel()"
    [placeholder]="transformedPlaceholder()" [disabled]="autoCompleteConfig().disabled || false"
    [dropdown]="autoCompleteConfig().dropdown || false" [multiple]="autoCompleteConfig().multiple || false"
    [minLength]="autoCompleteConfig().minLength || 1" [delay]="autoCompleteConfig().delay || 300"
    [forceSelection]="autoCompleteConfig().forceSelection || false"
    [autoHighlight]="autoCompleteConfig().autoHighlight || true"
    [showEmptyMessage]="autoCompleteConfig().showEmptyMessage || true" [emptyMessage]="transformedEmptyMessage()"
    [scrollHeight]="autoCompleteConfig().scrollHeight || '200px'" [group]="autoCompleteConfig().group || false"
    [optionGroupLabel]="transformedOptionGroupLabel()" [completeOnFocus]="autoCompleteConfig().completeOnFocus || false"
    [autofocus]="autoCompleteConfig().autofocus || false" [virtualScroll]="autoCompleteConfig().virtualScroll || false"
    [virtualScrollItemSize]="autoCompleteConfig().virtualScrollItemSize || 43"
    [lazy]="autoCompleteConfig().lazy || false" [readonly]="autoCompleteConfig().readonly || false"
    [dropdownMode]="autoCompleteConfig().dropdownMode || 'blank'" [unique]="autoCompleteConfig().unique !== false"
    [showClear]="autoCompleteConfig().showClear || false" [optionDisabled]="optionDisabled()"
    (completeMethod)="handleComplete($event)" (onSelect)="handleSelect($event)" (onUnselect)="handleUnselect($event)"
    (ngModelChange)="onValueChange($event)" (onFocus)="handleFocus()" (onBlur)="handleBlur()"
    (onKeyUp)="handleKeyUp($event)" (onShow)="handleShow()" (onHide)="handleHide()" (onClear)="handleClear($event)"
    (onDropdownClick)="handleDropdownClick($event)" (onLazyLoad)="handleLazyLoad($event)" appendTo="body">
    <!-- Item Template -->
    @if (itemTemplate()) {
    <ng-template let-item pTemplate="item">
        <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"></ng-container>
    </ng-template>
    }

    <!-- Selected Item Template -->
    @if (selectedItemTemplate()) {
    <ng-template let-value pTemplate="selectedItem">
        <ng-container *ngTemplateOutlet="selectedItemTemplate()!; context: { $implicit: value }"></ng-container>
    </ng-template>
    }

    <!-- Header Template -->
    @if (headerTemplate()) {
    <ng-template pTemplate="header">
        <ng-container *ngTemplateOutlet="headerTemplate()!"></ng-container>
    </ng-template>
    }

    <!-- Footer Template -->
    @if (footerTemplate()) {
    <ng-template pTemplate="footer">
        <ng-container *ngTemplateOutlet="footerTemplate()!"></ng-container>
    </ng-template>
    }

    <!-- Empty Template -->
    @if (emptyTemplate()) {
    <ng-template pTemplate="empty">
        <ng-container *ngTemplateOutlet="emptyTemplate()!"></ng-container>
    </ng-template>
    }

    <!-- Group Template -->
    @if (groupTemplate()) {
    <ng-template let-group pTemplate="group">
        <ng-container *ngTemplateOutlet="groupTemplate()!; context: { $implicit: group }"></ng-container>
    </ng-template>
    }

    <!-- Loader Template -->
    @if (loaderTemplate()) {
    <ng-template pTemplate="loader">
        <ng-container *ngTemplateOutlet="loaderTemplate()!"></ng-container>
    </ng-template>
    }

    <!-- Dropdown Icon Template -->
    @if (dropdownIconTemplate()) {
    <ng-template pTemplate="dropdownicon">
        <ng-container *ngTemplateOutlet="dropdownIconTemplate()!"></ng-container>
    </ng-template>
    }

    <!-- Remove Icon Template -->
    @if (removeIconTemplate()) {
    <ng-template pTemplate="removeicon">
        <ng-container *ngTemplateOutlet="removeIconTemplate()!"></ng-container>
    </ng-template>
    }

    <!-- Clear Icon Template -->
    @if (clearIconTemplate()) {
    <ng-template pTemplate="clearicon">
        <ng-container *ngTemplateOutlet="clearIconTemplate()!"></ng-container>
    </ng-template>
    }
</p-autoComplete>